export const SEARCH_REGION_AND_COUNTRIES = 'SEARCH_REGION_AND_COUNTRIES'

export const ERROR_STATE = 'ERROR_STATE'
